module.exports = __webpack_public_path__ + "91a3da5d6a3e6d39b856c03f6f1b85a1.svg";